import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class PermissionsRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_admin_token"
      )}`,
    };
  }
  async getPermissions() {
    try {
      const response = await axios.get(`${BASE_URL}/permissions`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }
}
const permissionsRequests = new PermissionsRequests();
export default permissionsRequests;
